module.exports = __webpack_public_path__ + "public/srwrdsBoost_Start.ogg";